import { render, staticRenderFns } from "./bid-details.vue?vue&type=template&id=c04fab76&"
import script from "./bid-details.vue?vue&type=script&lang=js&"
export * from "./bid-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports